module.exports = __webpack_public_path__ + "img/topic-presents.006cca8f.svg";